import { SearchLocation } from "@/interfaces/property.interface";
import { XIcon } from "lucide-react";
import { DropdownOption } from "./interface";

export interface SelectedOptionProps {
  option: DropdownOption & SearchLocation;
  onRemove: (option: DropdownOption & SearchLocation) => void;
}
export const SelectedOption: React.FC<SelectedOptionProps> = ({
  option,
  onRemove,
}) => {
  return (
    <div
      className="bg-primary rounded-lg py-[7px] px-[10px] text-white flex items-center gap-1 text-sm cursor-pointer"
      onClick={() => onRemove(option)}
    >
      <span>{option.label}</span>
      <span>
        <XIcon className="size-4" />
      </span>
    </div>
  );
};
